export default __webpack_public_path__ + "static/media/ContactsMobileActive.e26f8909.svg";